export const getDateFromCalVer = (calVerString: string): Date => {
  const parts = calVerString.split('.');

  if (parts.length !== 3) {
    throw new Error('Invalid CalVer format. Expected YYYY.M.D');
  }

  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-based
  const day = parseInt(parts[2], 10);

  // Validate the parts
  if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) {
    throw new Error('Invalid CalVer format. Each part must be a number');
  }

  return new Date(year, month, day);
};
